module.exports = __webpack_public_path__ + "build/assets/TruenoLt-f460eab11dcba2ac488f4785f2cda5fd.woff";